import { render, staticRenderFns } from "./ServiceReview.vue?vue&type=template&id=65134d40&"
import script from "./ServiceReview.vue?vue&type=script&lang=js&"
export * from "./ServiceReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports